<script setup lang="ts">
import EditAuthClassVODrawer from '@/pages/erp/ds/auth/view/ds-dataAuthClass-drawer.vue'
import type { AuthClassVOProperties } from '@/pages/erp/ds/auth/db/ds-dataAuthClass-types'
import Swal from 'sweetalert2'
definePage({
    meta: {
        action: 'manage',
        subject: 'DSDATAAUTHCLASS',
    },
})

const clazzId = ref()
const clazzName = ref()

// Data table options
const currentPage = ref(1)
const size = ref(10)
const sortOrder = ref()
const orderByCol = ref()

// Update data table options
const updateOptions = (options: any) => {
  sortOrder.value = options.sortBy[0]?.key
  orderByCol.value = options.sortBy[0]?.order
}

// Headers

const grid1Headers = [
    { title: '類別代碼', key: 'clazzId' },
    { title: '類別名稱', key: 'clazzName' },
    { title: '實作類別', key: 'clazzPath' },
    { title: '操作', key: 'actions', sortable: false}
]


// champ 後端分頁是從 0 開始
const page = computed((): number => currentPage.value - 1)

// 👉 Fetching users
const { data: authClassVOsData, execute: fetchAuthClassVOs } = await useApi<any>(createUrl('/ds/auth/dataAuthClass/searchAuthClassVO', {
  query: {
    clazzId,
    clazzName,
    page,
    size,
    orderByCol,
    sortOrder,
  },
}))

const datas = computed((): AuthClassVOProperties[] => authClassVOsData.value.data.authClassVOPage.content)
const totalDatas = computed(() => authClassVOsData.value.data.authClassVOPage.totalElements)

console.log('datas: ', datas)

const isEditDataDrawerVisible = ref(false)
const isNewData = ref(false)
const isCopyData = ref(false)

let voData = {}


const createData = () => {
  isEditDataDrawerVisible.value = true
  isNewData.value = true
  isCopyData.value = false
}

const editData = (authClassVOData: AuthClassVOProperties) => {
  voData = authClassVOData
  console.log('editAuthClassVO: ', voData)
  isEditDataDrawerVisible.value = true
  isNewData.value = false
  isCopyData.value = false
}

const copyData = (authClassVOData: AuthClassVOProperties) => {
    voData = authClassVOData
    console.log('copyAuthClassVO: ', voData)
    isEditDataDrawerVisible.value = true
    isNewData.value = true
    isCopyData.value = true
}

// 👉 Add new data
const addNewData = async (authClassVOData: AuthClassVOProperties) => {
  await $api('/ds/auth/dataAuthClass/createAuthClassVO', {
    method: 'POST',
    body: { authClassVO: authClassVOData },
  }).then(() => {
      $swal({
      position: 'top-end',
      icon: 'success',
      title: '新增成功',
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    })
  })

  // refetch data
  fetchAuthClassVOs()
}

const updateData = async (authClassVOData: AuthClassVOProperties) => {
  await $api('/ds/auth/dataAuthClass/updateAuthClassVO', {
    method: 'PUT',
    body: { authClassVO: authClassVOData },
  }).then(() => {
      $swal({
      position: 'top-end',
      icon: 'success',
      title: '修改成功',
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    })
  })

  // refetch data
  fetchAuthClassVOs()
}

  // 👉 Delete data
const deleteData = async (authClassVOData: AuthClassVOProperties) => {
  const { clazzId } = authClassVOData
    $swal({
    title: `確定要刪除 ${authClassVOData.clazzId} 資料?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "確定",
    cancelButtonText: "取消",
    reverseButtons: true
  }).then((result) => {
    if (result.isConfirmed) {
        $api(`/ds/auth/dataAuthClass/deleteAuthClassVO`, {
        method: 'DELETE',
        query: {
          clazzId
        }
      }).then(() => {
          $swal({
          position: 'top-end',
          title: "刪除成功",
          timer: 1500,
          icon: "success"
        });

        // refetch Data
        fetchAuthClassVOs()
      })
    }
  });

}

const clickRow = (event, select) => {
  console.log('clickRow: ', event, select)
  editData(select.item)
}

</script>

<template>
  <!-- 👉 Widgets -->

  <VCard class="mb-6">
    <VCardItem class="pb-2 pt-2">
      <VCardTitle>搜尋</VCardTitle>
    </VCardItem>

    <VCardText>
      <VRow>
        <VCol
         cols="12"
         sm="2"
        >
          <AppTextField
            v-model="clazzId"
            clearable
            clear-icon="mdi-close-circle"
            placeholder="請輸入類別代碼"
          />
        </VCol>
        <VCol
         cols="12"
         sm="2"
        >
          <AppTextField
            v-model="clazzName"
            clearable
            clear-icon="mdi-close-circle"
            placeholder="請輸入類別名稱"
          />
        </VCol>
      </VRow>
    </VCardText>

    <VDivider />

    <VCardText class="d-flex flex-wrap gap-4">
      <VSpacer />

      <div class="app-user-search-filter d-flex align-center flex-wrap gap-4">
        <!-- 👉 Add button -->
        <VBtn
                prepend-icon="tabler-plus"
                @click="createData"
        >
          新增資料授權實作類別註冊
        </VBtn>
      </div>
    </VCardText>

    <VDivider />

    <!-- SECTION datatable -->
    <VDataTableServer
            v-model:items-per-page="size"
            v-model:page="currentPage"
            :items="datas"
            :items-length="totalDatas"
            :headers="grid1Headers"
            class="text-no-wrap"
            @update:options="updateOptions"
    >

      <template #item.clazzId="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.clazzId }}
          </div>
      </template>

      <template #item.clazzName="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.clazzName }}
          </div>
      </template>

      <template #item.clazzPath="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.clazzPath }}
          </div>
      </template>

      <!-- Actions -->
      <template #item.actions="{ item }">
          <IconBtn @click="editData(item)">
              <VIcon icon="tabler-edit" />
              <v-tooltip
                      activator="parent"
                      location="bottom"
              >編輯</v-tooltip>
          </IconBtn>
          <IconBtn @click="copyData(item)">
              <VIcon icon="tabler-copy" />
              <v-tooltip
                      activator="parent"
                      location="bottom"
              >複製</v-tooltip>
          </IconBtn>
          <IconBtn @click="deleteData(item)">
              <VIcon icon="tabler-trash" />
              <v-tooltip
                      activator="parent"
                      location="bottom"
              >刪除</v-tooltip>
          </IconBtn>
      </template>

      <!-- pagination -->
      <template #bottom>
        <TablePagination
                v-model:page="currentPage"
                v-model:size="size"
                :items-per-page="size"
                :total-items="totalDatas"
        />
      </template>
    </VDataTableServer>
    <!-- SECTION -->
  </VCard>
  <!-- 👉 Edit -->
  <EditAuthClassVODrawer
          v-model:isDrawerOpen="isEditDataDrawerVisible"
          :authClassVO-data="voData"
          :is-new="isNewData"
          :is-copy="isCopyData"
          @create-data="addNewData"
          @update-data="updateData"
  />

</template>
